import { z } from "zod";

export const cartItemInputSchema = z.object({
  productId: z.string().uuid(),
  qty: z.number().int().positive(),
});
export type CartItemInput = z.infer<typeof cartItemInputSchema>;

export const checkoutInputSchema = z.object({
  counterpartyId: z.string().uuid(),
  deliveryType: z.enum(["courier", "pickup"]),
  deliveryAddress: z.string().optional(),
  deliveryCostKopecks: z.number().int().nonnegative().optional(),
  lines: z.array(z.object({
    productId: z.string().uuid(),
    warehouseId: z.string().uuid(),
    qty: z.number().int().positive(),
  })).min(1),
});
export type CheckoutInput = z.infer<typeof checkoutInputSchema>;
